import { useInfiniteQuery } from '@tanstack/react-query';
import { changeHistoryViewerApi } from '../api/changeHistoryViewerApi';

const PAGE_SIZE = 20;

/**
 * GET /change-history-viewer/timeline — revision 타임라인 (커서 무한 스크롤)
 * queryKey: ['change-history-viewer', 'timeline', entityId]
 *
 * entityId 가 undefined 이면 쿼리 비활성화 (엔티티 미선택 상태)
 */
export function useRevisionTimeline(entityId: number | undefined) {
  return useInfiniteQuery({
    queryKey: ['change-history-viewer', 'timeline', entityId] as const,
    queryFn: ({ pageParam }) =>
      changeHistoryViewerApi.getTimeline({
        entityId: entityId!,
        cursor: (pageParam as string | undefined) ?? undefined,
        size: PAGE_SIZE,
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) =>
      lastPage.hasMore ? (lastPage.nextCursor ?? undefined) : undefined,
    enabled: entityId !== undefined,
    staleTime: 30_000,
  });
}
